//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('department', {
//        templateUrl: 'views/components/views/department/department.template.html?v=' + module.version, 
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'departmentService', 'logisticService', 'economyService', 'typeaheadService', function ($stateParams, stateService, utilityService, translateService, modalService, departmentService, logisticService, economyService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                departmentId: $stateParams.department_id,
//                deliveryCustomerButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('customersmenu', { cust_no: vm.model.edit.delivery_cust_no }) }
//                ],
//                edit: {},
//                selectListCompanies: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await departmentService.getDepartment({ department_id: vm.model.departmentId }))[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            function retrieveCustomer() {
//                if (utilityService.validateParmsValue(vm.model.edit.delivery_cust_no) !== true) return;

//                economyService.getCustomer({ cust_no: vm.model.edit.delivery_cust_no }).then(function (response) {
//                    vm.model.edit.delivery_address = response[0].cust_address;
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value, id) {
//                switch (id) {
//                    case 'delivery_cust_name':
//                        vm.model.edit[id] = value;

//                        return typeaheadService.searchCustomer({
//                            cust_name: vm.model.edit[id] || '',
//                            filtertype: '',
//                            filtervalue: '',
//                            custtype: 'S',
//                            lastselect: 'SEARCH'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onTypeaheadSelected = function (item, id) {
//                switch (id) {
//                    case 'delivery_cust_name':
//                        if (item) {
//                            vm.model.edit.delivery_cust_no = item?.item_id ?? '0';
//                            vm.model.edit.delivery_cust_name = item?.item_name ?? '';

//                            retrieveCustomer();
//                        } else {
//                            vm.onTypeaheadClear('delivery_cust_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onTypeaheadChanged = function (value, item, id) {
//                switch (id) {
//                    case 'delivery_cust_name':
//                        vm.model.edit.delivery_cust_name = value;

//                        if (value) {
//                            if (item?.item_id) {
//                                vm.model.edit.delivery_cust_no = item.item_id;
//                            }
//                        } else {
//                            vm.onTypeaheadClear('delivery_cust_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onTypeaheadClear = function (id) {
//                switch (id) {
//                    case 'delivery_cust_name':
//                        vm.model.edit.delivery_cust_no = '0';
//                        vm.model.edit.delivery_cust_name = '';
//                        vm.model.edit.delivery_address = '';
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                departmentService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: (dialogItself) => {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//                loadCompanies();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
